// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"UtilBox_searchBox__1reX-","icon":"UtilBox_icon__3jlQK","cancel":"UtilBox_cancel__2uaYb","hotkeys":"UtilBox_hotkeys__2plpU"};